import { type FC } from 'react';
import { FormattedMessage } from 'dibs-react-intl';

import { useMenu } from 'dibs-elements/exports/useMenu';
import { Tooltip } from 'dibs-elements/exports/Tooltip';
import { Link } from 'dibs-elements/exports/Link';
import NoteEdit from 'dibs-icons/exports/legacy/NoteEdit';
import TrashCan from 'dibs-icons/exports/legacy/TrashCan';
import ReplaceArrows from 'dibs-icons/exports/legacy/ReplaceArrows';

import styles from './InlineMediaUploaderTooltipMenu.scss';

type Props = {
    isVisible: boolean;
    onClose: () => void;
    onDelete: () => void;
    onCrop: () => void;
    onReplace: () => void;
};

export const InlineMediaUploaderTooltipMenu: FC<Props> = ({
    isVisible,
    onClose,
    onDelete,
    onCrop,
    onReplace,
}) => {
    const menuRef = useMenu(isVisible, onClose, true);

    return (
        <Tooltip
            isVisible={isVisible}
            closeOnOutsideClick
            onClose={onClose}
            direction="bottom"
            paddingSize="small"
        >
            <ul className={styles.menuItems} ref={menuRef}>
                <Link role="menuitem" onClick={onDelete} className={styles.link}>
                    <li className={styles.menuItem}>
                        <TrashCan className={styles.menuIcon} />
                        <FormattedMessage
                            id="nft.publicProfile.mediaUploader.delete"
                            defaultMessage="Delete Image"
                        />
                    </li>
                </Link>
                <Link role="menuitem" onClick={onReplace} className={styles.link}>
                    <li className={styles.menuItem}>
                        <ReplaceArrows className={styles.menuIcon} />
                        <FormattedMessage
                            id="nft.publicProfile.mediaUploader.replace"
                            defaultMessage="Replace Image"
                        />
                    </li>
                </Link>
                <Link role="menuitem" onClick={onCrop} className={styles.link}>
                    <li className={styles.menuItem}>
                        <NoteEdit className={styles.menuIcon} />
                        <FormattedMessage
                            id="nft.publicProfile.mediaUploader.crop"
                            defaultMessage="Crop Image"
                        />
                    </li>
                </Link>
            </ul>
        </Tooltip>
    );
};
